import { render, staticRenderFns } from "./FrontendLayout.vue?vue&type=template&id=094c955a&scoped=true&"
import script from "./FrontendLayout.vue?vue&type=script&lang=js&"
export * from "./FrontendLayout.vue?vue&type=script&lang=js&"
import style0 from "./FrontendLayout.vue?vue&type=style&index=0&id=094c955a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094c955a",
  null
  
)

export default component.exports